import React, { Fragment } from "react";
import styled from "styled-components";
import { Delete } from "@material-ui/icons";

import SecondaryButton from "./SecondaryButton";

const DeleteButton = ({ onClick, ...other }) => (
  <SecondaryButton onClick={onClick} {...other}>
    <Delete />
    DELETE
  </SecondaryButton>
);
export default DeleteButton;
